export type ToastPayload = {
  message: string;
  duration?: number;
};

type ToastSubscriber = (payload: ToastPayload) => void;

const subscribers = new Set<ToastSubscriber>();
const pending: ToastPayload[] = [];

export const emitToast = (message: string, duration?: number) => {
  const payload = { message, duration };
  if (subscribers.size === 0) {
    pending.push(payload);
    return;
  }
  subscribers.forEach((fn) => fn(payload));
};

export const subscribeToast = (fn: ToastSubscriber) => {
  subscribers.add(fn);
  if (pending.length > 0) {
    const queued = pending.splice(0, pending.length);
    queued.forEach((payload) => fn(payload));
  }
  return () => {
    subscribers.delete(fn);
  };
};
